<template>
  <aside class="support-sub-main" v-if="$t('m.lang') == 'en'">
    <dl class="support-list">
      <dt class="support-title">Frequently Asked Questions</dt>
      <dd
        class="support-item"
        v-for="(item, index) in Frequently.faqListUl"
        :key="index"
      >
        <a
          :href="
            `/support/` +
            item.value.replaceAll(` `, `-`).replaceAll(`/`, `&`) +
            '/'
          "
          >{{ item.value }}</a
        >
      </dd>
    </dl>
  </aside>
  <aside class="support-sub-main" v-if="$t('m.lang') == 'zh'">
    <dl class="support-list">
      <dt class="support-title">常见问题</dt>
      <dd
        class="support-item"
        v-for="(item, index) in zhFrequently.faqListUl"
        :key="index"
      >
        <a @click="getTitle(item.value)">{{ item.value }}</a>
      </dd>
    </dl>
  </aside>
</template>

<script>
export default {
  name: "Freq",
  props: ["Frequently"],
  data() {
    return {
      Frequently: "",
      zhFrequently: "",
    };
  },
  created() {
    this.getFreqList();
    this.getZhFreqList();
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  methods: {
    getTitle(title) {
      var obj = this.$route.params.title;
      axios({
        url: "https://64qx6jnt0a.execute-api.cn-north-1.amazonaws.com.cn/Prod/",
        method: "POST",
        data: {
          methods: "getLangkeys",
          title: title,
        },
      }).then((result) => {
        this.$router.push(
          "/support-zh/" +
            result.data.Items[0].langkeys
              .replaceAll(` `, `-`)
              .replaceAll(`/`, `&`) +
            "/"
        );
      });
    },
    async getFreqList() {
      await this.$http({
        url: "https://64qx6jnt0a.execute-api.cn-north-1.amazonaws.com.cn/Prod/",
        method: "POST",
        data: {
          methods: "getFaqList",
          Id: "Frequently",
        },
      })
        .then((res) => {
          this.Frequently = res.data.Item.faqList;
        })
        .catch((err) => {});
    },
    async getZhFreqList() {
      await this.$http({
        url: "https://64qx6jnt0a.execute-api.cn-north-1.amazonaws.com.cn/Prod/",
        method: "POST",
        data: {
          methods: "getFaqList",
          Id: "zhFrequently",
        },
      })
        .then((res) => {
          this.zhFrequently = res.data.Item.faqList;
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/support.scss";
</style>
